import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Grid, Icon } from 'semantic-ui-react';
import { Input, InputWithSuggestions, TextArea } from '../../../../Elements';
import { GlobalNotifications, Intent } from '../../../../Modules';
import { RootConsumer } from '../../../../RootComponent';
import ClipboardButton from 'react-clipboard.js';
import styles from './Share.scss';

class DocumentShareOptions extends Component {
  static propTypes = {
    canEmail: PropTypes.bool.isRequired,
    documentType: PropTypes.string.isRequired,
    emailSuggestions: PropTypes.array.isRequired,
    permissionsNode: PropTypes.node.isRequired,
    shareUrl: PropTypes.string.isRequired,
    showLink: PropTypes.bool.isRequired,
    submitted: PropTypes.bool.isRequired,
    toggleLink: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      to: '',
      cc: '',
      subject: '',
      message: '',
      showCc: false
    };
    this.onFocus = this.onFocus.bind(this);
    this.onSuccessfulCopy = this.onSuccessfulCopy.bind(this);
    this.onTextChange = this.onTextChange.bind(this);
    this.onEmailChange = this.onEmailChange.bind(this);
  }

  onFocus(e) {
    e.target.select();
  }

  onEmailChange(e, { value, name }) {
    this.setState({ [name]: value });
  }

  onTextChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  onSuccessfulCopy() {
    GlobalNotifications.show({
      message: `Successfully copied ${this.props.documentType} URL`,
      intent: Intent.SUCCESS
    });
  }

  render() {
    const {
      canEmail,
      documentType,
      emailSuggestions,
      permissionsNode,
      shareUrl,
      showLink,
      submitted,
      toggleLink
    } = this.props;
    const { to, cc, subject, message, showCc } = this.state;

    const copyButton = () =>
      <ClipboardButton
        option-text={() => shareUrl}
        onSuccess={this.onSuccessfulCopy}
        className='ui right icon button button'
      >
        <span>
          Copy &nbsp;<Icon name='copy outline' />
        </span>
      </ClipboardButton>;

    return (
      <RootConsumer>
      {({ isMobile }) => (
        <Grid padded relaxed stackable centered>
          <Grid.Row>
            <Grid.Column>
              <div>
                {showLink &&
                  <div>
                    <p style={{ textAlign: 'left' }}>
                      You can share this {documentType} with anyone through this
                      link.
                    </p>
                    <Input
                      fluid
                      name='share_url'
                      onFocus={this.onFocus}
                      value={shareUrl}
                      onChange={() => {}}
                      action={copyButton()}
                      style={{ marginTop: '2em', marginBottom: '2em' }}
                    />
                    {permissionsNode}
                    {canEmail &&
                      <p style={{ marginTop: '1em' }}>
                        <a onClick={toggleLink}>
                          Share via email <Icon name='mail outline' />
                        </a>
                      </p>}
                  </div>}
                {!showLink &&
                  canEmail &&
                  <div style={{ position: 'relative' }}>
                    <InputWithSuggestions
                      label='To'
                      name='to'
                      value={to}
                      onChange={this.onEmailChange}
                      submitted={submitted}
                      placeholder='Email address...'
                      className={!showCc ? styles.toField : null}
                      fluid
                      required
                      validations='isEmail'
                      autoComplete='off'
                      options={emailSuggestions}
                      validationError='Valid email address required'
                    />
                    <br />
                    {showCc &&
                      <React.Fragment>
                        <InputWithSuggestions
                          label='Cc'
                          name='cc'
                          value={cc}
                          onChange={this.onEmailChange}
                          submitted={submitted}
                          placeholder='Email address...'
                          fluid
                          validations='isEmail'
                          autoComplete='off'
                          options={emailSuggestions}
                          validationError='Valid email address required'
                        />
                        <br />
                      </React.Fragment>}
                    {!showCc &&
                      <a
                        style={{
                          position: 'absolute',
                          top: isMobile ? '2.125em' : '2.25em',
                          right: '1.125em'
                        }}
                        onClick={() => this.setState({ showCc: true })}
                      >
                        Cc
                      </a>}
                    <Input
                      label='Subject'
                      name='subject'
                      value={subject}
                      placeholder='Email subject...'
                      onChange={this.onTextChange}
                      submitted={submitted}
                      fluid
                      required
                      validationError='Subject is required'
                    />
                    <br />
                    <div className='ui form'>
                      <div style={{ marginBottom: '0.25em' }}>
                        <strong>
                          <label htmlFor='message'>Message</label>
                        </strong>
                      </div>
                      <TextArea
                        placeholder='Enter a personal message'
                        name='message'
                        id='message'
                        value={message}
                        onChange={this.onTextChange}
                      />
                    </div>
                    <p>
                      <a onClick={toggleLink}>
                        <br />
                        Get shareable link <Icon name='linkify' />
                      </a>
                    </p>
                  </div>}
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      )}
      </RootConsumer>
    );
  }
}

export default DocumentShareOptions;



// WEBPACK FOOTER //
// ./webpack/components/Document/Sections/Actions/Share/ShareOptions.js